import { LocationDto } from "@apiModels/LocationDto.csharp";

export const isLocationSelected = (location: LocationDto) => {
  return location && location.id !== "-1" && location.id !== "";
};
